/*
 * @Description:
 * @Author: liXinMan
 * @Date: 2021-12-14 09:52:32
 * @LastEditors: liXinMan
 * @LastEditTime: 2021-12-16 14:51:47
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'SelectLanguage',
		component: () => import(/* webpackChunkName: "about" */ '../views/language.vue')
	},
	{
		path: '/pagesWorks',
		name: 'PagesWorks',
		component: () => import(/* webpackChunkName: "about" */ '../views/works.vue')
	},
	{
		path: '/upload',
		name: 'PagesUpload',
		component: () => import(/* webpackChunkName: "about" */ '../views/upload.vue')
	},
	{
		path: '/work/:workId',
		name: 'PagesWork',
		props: true,
		component: () => import(/* webpackChunkName: "about" */ '../views/work.vue')
	},
	{
		path: '/finish',
		name: 'PagesFinish',
		props: true,
		component: () => import(/* webpackChunkName: "about" */ '../views/finish.vue')
	}
]
console.log(process.env.BASE_URL);
const router = new VueRouter({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes
})

router.beforeEach((to, from, next) => {
	// eslint-disable-next-line
	if (_hmt) {
		if (to.path) {
			// eslint-disable-next-line
			_hmt.push(['_trackPageview', to.fullPath]);
		}
	}
	next()
})

export default router
